import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, legacy_createStore as createStore } from 'redux';
import reducers from './reducers';

const hist = createBrowserHistory();

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(reducers, composeEnhancers(applyMiddleware()));
export const history = hist;
